export const environment = {
    stage: true,
    anthem: false,
    envName: 'stage',
    mapBoxToken: 'pk.eyJ1Ijoic2FjaGluZHJhc2luZ2giLCJhIjoiY2t1aDBwa2F3MDlkMzJ3bjZiajF6ZmZ1ZyJ9.He6aGRTLWQY5Q7EeU_XpWw',
    production: false,
    platinum: false,
    baseUrl: 'https://webapistaging.routespro.com/'//staging url
    //baseUrl: 'https://webapi.routespro.com/' //production user
};